import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { RoutinesScreen } from "../../screens/routines/index.ts";

/**
 * `/routines`: what Adea does on its own. A person's own routines (made and changed in the sheet) and the built-in
 * ones, each switched on or off here, with its history of runs (each a thread). Pages sent on a schedule show here
 * too, with a link to their page, where the schedule is changed.
 */
export const Route = createFileRoute("/_app/routines")({
  loader: ({ context }) => context.queryClient.prefetchQuery(actions.queryOptions("routines.list", {})),
  component: RoutinesScreen,
});
